function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { getTypographyTag } from 'theming/typography';
import * as S from './Typography.styles';
const Typography = /*#__PURE__*/React.forwardRef(({
  variant,
  size,
  customTag,
  children,
  italic,
  uppercase,
  weight,
  className
}, ref) => {
  const containerProps = {
    variant,
    size,
    italic,
    uppercase,
    weight,
    className
  };
  const tag = customTag ?? getTypographyTag(variant, size);
  return /*#__PURE__*/React.createElement(S.Container, _extends({
    as: tag,
    ref: ref
  }, containerProps), children);
});
export { Typography };